import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { TokenEncryptionService } from '../Services/token-encryption.service';

@Injectable({
    providedIn: 'root'
})
export class MagicLinkGuard implements CanActivate {

    constructor(private tokenEncryptionService: TokenEncryptionService) { }

    canActivate(): boolean | UrlTree {
        // Only check for magic links on the root route
        if (window.location.pathname === '/') {
            const urlParams = new URLSearchParams(window.location.search);
            const loginCode = urlParams.get('login_code');
            const intent = urlParams.get('intent');

            if (loginCode) {
                console.log('Magic link detected, redirecting to /auth');
                // Redirect to auth route with magic link parameters
                let authUrl = `/auth?login_code=${loginCode}`;
                
                if (intent) {
                    authUrl += `&intent=${intent}`;
                }

                // Get email from encrypted storage or localStorage if available
                const encryptedEmail = this.tokenEncryptionService.getEncryptedItem<string>('current_email') as string;
                const email = encryptedEmail || localStorage.getItem('user_email');
                if (email) {
                    authUrl += `&email=${encodeURIComponent(email)}`;
                }

                window.location.href = authUrl;
                return false;
            }
        }

        // Allow normal navigation for all other cases
        return true;
    }
}
